import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Toolbar,
  Sort,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { GetPartById, GetPartUsedById } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";
import TextInputField from "../../components/TextInputField";

const PartUsed = () => {
  const navigate = useNavigate();
  let param = useParams();
  const part_id = param.p_id;
  const [Part, setPart] = useState("");
  const [Parts, setParts] = useState([]);
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(true);

  const colsGrid = [
    {
      field: `part_number`,
      headerText: "Parent PN",
      minWidth: "110",
      width: "115",
      maxWidth: "120",
      textAlign: "center",
    },
    {
      field: `category`,
      headerText: "Category",
      minWidth: "125",
      width: "135",
      maxWidth: "150",
      textAlign: "left",
    },
    {
      field: `description`,
      headerText: "Description",
      minWidth: "140",
      width: "240",
      maxWidth: "440",
      textAlign: "left",
    },
    {
      field: `in_stock`,
      headerText: "Stk Qty",
      minWidth: "75",
      width: "80",
      maxWidth: "85",
      textAlign: "right",
    },
    {
      field: `quantity`,
      headerText: "Asm Qty",
      minWidth: "85",
      width: "85",
      maxWidth: "90",
      textAlign: "right",
    },
    {
      field: `ref_des`,
      headerText: "Ref Des",
      minWidth: "130",
      width: "180",
      maxWidth: "320",
      textAlign: "left",
    },
    {
      field: "dni",
      headerText: "DNI",
      minWidth: "60",
      width: "60",
      maxWidth: "70",
      textAlign: "center",
    },
    {
      field: `alternate_part_number`,
      headerText: "Alternate PN",
      minWidth: "110",
      width: "115",
      maxWidth: "120",
      textAlign: "center",
    },
    {
      field: `alternate_part_description`,
      headerText: "Alternate Desc",
      minWidth: "140",
      width: "240",
      maxWidth: "440",
      textAlign: "left",
    },
  ];

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Part");
  };

  useEffect(() => {
    async function fetchData() {
      if (part_id) {
        TimeoutUtility.resetTimeout();
        setloading(true);
        trackPromise(
          Promise.all([GetPartById(part_id), GetPartUsedById(part_id)])
            .then(([res1, res2]) => {
              setPart(`${res1.data.part_number} - ${res1.data.description}`);
              setParts(res2.data);
            })
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [part_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="APPROVED PARTS" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={8} className="container-col">
              <TextInputField
                label="Part Number & Description:"
                name="location"
                value={Part}
                placeholder="Part Number & Description:"
                disabled
              />
            </Col>
            <Col md={12} className="container-col">
              {loading && promiseInProgress ? (
                <LoadingIndicator />
              ) : (
                <GridComponent
                  dataSource={Parts}
                  height="calc(60vh - 116px)"
                  allowSorting
                  allowResizing
                  className="custom-grid1 mt-4"
                  rowHeight={30}
                  toolbar={["Search"]}
                >
                  <ColumnsDirective>
                    {colsGrid.map((item, index) => (
                      <ColumnDirective key={index} {...item} />
                    ))}
                  </ColumnsDirective>
                  <Inject services={[Resize, Toolbar, Sort]} />
                </GridComponent>
              )}
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default PartUsed;
